import React from 'react';
import PropTypes from 'prop-types';
import { View } from '@react-pdf/renderer';
import {
    styles, preparePdfTheme, formatDate,
    PdfDocument, MetaCard, PartiesRow, LineItemsTable, TotalsCard, InfoCard,
} from './pdfCommon';

export { THEMES } from './pdfCommon';

const QuotationPDF = ({ data, companyData, tableItem, tableColum, currencySettings, Calculation, profile, accountJsonData, theme, logoSrc }) => {
    const logo = logoSrc || companyData?.accountLogo;
    const p = {
        ...preparePdfTheme(theme, logo),
        logoRatio: companyData?.logoSize ? companyData.logoSize.width / companyData.logoSize.height : 1,
    };

    return (
        <PdfDocument
            documentTitle={`Quote ${data?.quotesNumber || ''}`}
            headline="QUOTE"
            number={data?.quotesNumber}
            p={p}
            companyData={companyData}
            profile={profile}
        >
            <MetaCard
                items={[
                    ['Issue date', formatDate(data?.issueDate, profile)],
                    ['Expiry date', formatDate(data?.validUntil, profile)],
                ]}
            />

            <PartiesRow companyData={companyData} data={data} accountJsonData={accountJsonData} />

            <LineItemsTable
                tableItem={tableItem}
                tableColum={tableColum}
                currencySettings={currencySettings}
                profile={profile}
                p={p}
            />

            <View style={styles.totalsRow} wrap={false}>
                <TotalsCard Calculation={Calculation} currencySettings={currencySettings} p={p} />
            </View>

            {data?.termsAndCondition ? (
                <InfoCard title="Terms and Conditions" html={data.termsAndCondition} p={p} style={{ marginTop: 14 }} />
            ) : null}
        </PdfDocument>
    );
};

QuotationPDF.propTypes = {
    data: PropTypes.object.isRequired,
    companyData: PropTypes.object.isRequired,
    tableItem: PropTypes.array.isRequired,
    tableColum: PropTypes.array.isRequired,
    currencySettings: PropTypes.object.isRequired,
    Calculation: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    accountJsonData: PropTypes.object.isRequired,
    theme: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    logoSrc: PropTypes.string,
};

QuotationPDF.defaultProps = {
    theme: 'growsquare',
    logoSrc: undefined,
};

export default QuotationPDF;